import { all, call, put, select, takeLatest } from "redux-saga/effects";

import { Exercicios2Props } from "../../interfaces/exercicio.interface";
import {
	PacientesProps,
	UserProps,
} from "../../interfaces/pacientes.interface";
import { TypesErrorRequest } from "./../../utils/types";
import { DashBoardActions, Types } from "../../store/ducks/dashboard";
import { loadStorage, persistStorage } from "../../utils/base_async_storage";
import { ExerciciosActions } from "../ducks/exer";
import { ManageProtocolActions } from "../ducks/manage_protocols";
import { AppActions } from "../ducks/app";
import { getTimeExecFunction, getTimeout, sendErrorSentryOrLocalHost } from "../../utils/funcs";
import { apiFetch, apiFetchWrite } from "../../services/httpClient";
import { getDatabase, ref, push } from "firebase/database";
import moment from "moment";
import * as Sentry from "@sentry/react";
import { Console } from "console";
import { TextsProps } from "../../database/txt.interface";
import axios from "axios";
import { panelCreatedProps } from "../../pages/DashDyanalabs/Dashboard";
import { FiltrosResponse } from "../ducks/Models";
import { AnswerNpsProps } from "../models";

function* getAvaliadores(): any {
	let status = 0;
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	const parametros = yield select(
		(state: any) => state.dashboard.filtros_avaliadores_request
	);

	parametros["TOKEN"] = user_logado.token;

	async function apiCall() {
		try {
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(parametros),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/usuarios_filtro`,
				requestOptions
			);
			status = res.status;
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar avaliadores - getAvaliadores',
				tags: {endpoint: '/syncs/usuarios_filtro', file: 'src/store/sagas/dashboard.ts' },
			})
			throw e;
		}
	}

	try {
		const response = yield call(apiCall);

		if (status == 200) {
			yield put(DashBoardActions.set_avaliadores(response.usuarios));
			yield put(DashBoardActions.total_avaliadores(response.total));
		} else {
			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.FAIL,
					message_toast: "Erro ao buscar avaliadores " + status,
				})
			);
		}
	} catch (e) {}
}

function* getPacientes(action: any): any {
	let status = 0;
	const append = !!action?.payload?.append;
	const user_logado: UserProps = yield select((state: any) => state.auth.user);
	const patientEtiqueta = yield select(
		(state) => state.app.set_patient_in_etiqueta
	);
	const filtros = yield select(
		(state: any) => state.dashboard.filtros_pacintes_request
	);
	const parametros: any = {
		...filtros,
		TOKEN: user_logado.token,
	};
	if (
		append &&
		action.payload?.inicio != null &&
		action.payload?.fim != null
	) {
		parametros.inicio = action.payload.inicio;
		parametros.fim = action.payload.fim;
	}

	async function apiCall() {
		try {
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(parametros),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/usuarios_filtro`,
				requestOptions
			);
			status = res.status;
			const response: any = await res.json();
			return response;
		} catch (error) {
			sendErrorSentryOrLocalHost(error,{
				message: 'Erro ao buscar paciente - getPacientes',
				tags: {endpoint: '/syncs/usuarios_filtro', file: 'src/store/sagas/dashboard.ts' },
			} )
			throw error;
		}
	}

	try {
		const response = yield call(apiCall);
		yield put(DashBoardActions.set_button_search(false));
		if (status == 200) {
			if (patientEtiqueta) {
				yield put(
					AppActions.set_get_patient_in_etiqueta(false, response.usuarios)
				);
			} else {
				yield put(
					DashBoardActions.paciente_success(response.usuarios || [], append, {
						inicio: parametros.inicio,
						total: response.total,
					})
				);
				if (response.total != null) {
					yield put(DashBoardActions.total_pacientes(response.total));
				}
			}
		} else {
			yield put(DashBoardActions.paciente_stop_request());
			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.FAIL,
					message_toast: "Erro ao buscar pacientes " + status,
				})
			);
		}
	} catch (e) {
		yield put(DashBoardActions.paciente_stop_request());
	}
}

function* getPacientesNotification(): any {
	let status = 0;
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	const parametros = yield select(
		(state: any) => state.dashboard.filtros_pacintes_notification_request
	);
	parametros["TOKEN"] = user_logado.token;

	async function apiCall() {
		try {
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(parametros),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/usuarios_filtro`,
				requestOptions
			);
			status = res.status;
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar notificacoes usuario - getPacientesNotification',
				tags: {
					endpoint: '/syncs/usuarios_filtro',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw e;
		}
	}

	try {
		const response = yield call(apiCall);
		console.log("🚀 ~ dashboard.ts:184 ~ getPacientesNotification ~ response:", response)
		if (status == 200) {
			yield put(
				DashBoardActions.paciente_notification_success(response.usuarios)
			);
		} else {
			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.FAIL,
					message_toast: "Erro ao buscar pacientes " + status,
				})
			);
		}
	} catch (e) {
		console.log("🚀 ~ dashboard.ts:199 ~ getPacientesNotification ~ e:", e)
		yield put(DashBoardActions.paciente_stop_request());
	}
}

function* getMaisVisitados(): any {
	let status = 0;
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	const parametros = {
		TOKEN: user_logado.token,
		limite: 10,
	};

	async function apiCall() {
		try {
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(parametros),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/acessos_pacientes`,
				requestOptions
			);
			status = res.status;
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar pacientes mais visitados - getMaisVisitados',
				tags: {
					endpoint: '/syncs/acessos_pacientes',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw e;
		}
	}

	try {
		const response = yield call(apiCall);
		if (status == 200) {
			yield put(
				DashBoardActions.set_pacientes_mais_visitados(
					response.config_lista_usuarios
				)
			);
		} else {
			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.FAIL,
					message_toast: "Erro ao buscar pacientes mais visitados" + status,
				})
			);
		}
	} catch (e) {
	}
}

function* getProtocolos(): any {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const da = {
				TOKEN: user_logado.token,
				PROTOCOLO_LIBERADO: true,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(da),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/protocolos`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar protocolos - getProtocolos',
				tags: {
					endpoint: '/syncs/protocolos',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw e;
		}
	}

	try {
		const data = yield call(apiCall);
		yield put(ManageProtocolActions.set_protocolos(data.protocolos));
		yield put(DashBoardActions.set_search_protocol(data.protocolos));
		yield put(DashBoardActions.call_categorias_protocolos());
	} catch (e) {}
}

function* getExercises() {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const da = {
				TOKEN: user_logado.token,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(da),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/exercicios`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar exercicios - getExercises',
				tags: {
					endpoint: '/syncs/exercicios',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw e;
		}
	}

	try {
		const { exercicios, agrupamentos } = yield call(apiCall);
		const exerNotDeleted = exercicios.filter(
			(i: Exercicios2Props) => i.EXERCICIO_EXCLUIDO == false
		);
		const exerDeleted = exercicios.filter(
			(i: Exercicios2Props) =>
				i.EXERCICIO_EXCLUIDO == true && i.ID_MUSCULO != null
		);
		yield put(ExerciciosActions.set_exercicios(exerNotDeleted));
		yield put(ExerciciosActions.set_search_exercise(exerNotDeleted));
		yield put(ExerciciosActions.set_exercicios_deletado(exerDeleted));
		yield put(DashBoardActions.set_agrupamentos(agrupamentos));
	} catch (e) {}
}

function* getExecucoes() {
	interface Request {
		TOKEN: string;
		EXCLUIDAS?: string;
		ID_USUARIO?: number;
	}
	const TimeInitial = new Date().getTime();
	yield put(DashBoardActions.execucoes_request_loading(true));
	yield put(DashBoardActions.execucoes_request_sucess([]));

	const user_logado: UserProps = yield select((state: any) => state.auth.user);
	const paciente: PacientesProps = yield select(
		(state: any) => state.app.is_open_paciente
	);

	const execucoes_excluidas: PacientesProps = yield select(
		(state: any) => state.dashboard.execucoes_excluidas
	);
	async function apiCall() {
		try {
			const data: Request = {
				TOKEN: user_logado.token,
			};
			if (execucoes_excluidas) {
				data.EXCLUIDAS = "S";
			} else {
				data.ID_USUARIO = paciente.ID_USUARIO;
			}
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(data),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/execucoes`,
				requestOptions
			);
			if (res.status == 400) {
				try {
					const dataAtual = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
					const reference = getDatabase();
					push(ref(reference, "Sync_execucoes"), {
						current_date: dataAtual,
						status: `${res.status}`,
					});
				} catch (error) {
					sendErrorSentryOrLocalHost(error,{
						message: 'Erro ao buscar execucoes - getExecucoes',
						tags: {
							endpoint: '/syncs/execucoes',
							file: 'src/store/sagas/dashboard.ts' 
						},
					})
				}
			}

			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar execucoes - getExecucoes',
				tags: {
					endpoint: '/syncs/execucoes',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw e;
		}
	}

	try {
		const { exibir, ocultar } = yield call(apiCall);
		yield put(DashBoardActions.execucoes_request_sucess(exibir));
	} catch (e) {
		yield put(DashBoardActions.execucoes_request_loading(false));
	} finally {
		yield put(DashBoardActions.execucoes_request_loading(false));
	}
	const TimeFinal = new Date().getTime();

	getTimeExecFunction(
		TimeInitial,
		TimeFinal,
		"Function_getExecucoes",
		user_logado
	);
	getTimeout(
		TimeInitial,
		TimeFinal,
		"TIMEOUT_Function_getExecucoes",
		user_logado?.ID_USUARIO
	);
}

function* getEtiquetas() {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const da = {
				TOKEN: user_logado.token,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(da),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/etiquetas`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar etiquetas - getEtiquetas',
				tags: {
					endpoint: '/syncs/etiquetas',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw e;
		}
	}

	try {
		const { etiquetas } = yield call(apiCall);
		yield put(DashBoardActions.etiquetas_request_success(etiquetas));
	} catch (e) {
		console.log("🚀 ~ dashboard.ts:466 ~ getEtiquetas ~ e:", e)
		
	}
}

function* getNotificacoes() {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);
	const language: string = yield select((state: any) => state.configs.language);

	let date = "0000-00-00 00:00:00";
	const txSyncDataHora: string = yield call(
		loadStorage,
		"SyncDataHoraNotifications"
	);

	if (txSyncDataHora) {
		date = txSyncDataHora;
	}
	async function apiCall() {
		try {
			const da = {
				TOKEN: user_logado.token,
				SyncDataHora: date,
				txIdioma: language?.toLowerCase(),
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(da),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/notificacoes`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar notificacoes - getNotificacoes',
				tags: {
					endpoint: '/syncs/notificacoes',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw e;
		}
	}
	interface ApiCallProps {
		SyncDataHora: string;
		notificacoes: [];
	}

	try {
		const { SyncDataHora, notificacoes }: ApiCallProps = yield call(apiCall);

		const exist_notifications: [] = yield call(loadStorage, "notifications");

		if (exist_notifications) {
			const old_notifications = exist_notifications.map((element: any) => {
				return {
					...element,
					IS_NEW: false,
				};
			});
			const new_notifications = notificacoes.map((element: any) => {
				return {
					...element,
					IS_NEW: true,
				};
			});
			yield put(
				DashBoardActions.notificacoes_request_success([
					...new_notifications,
					...old_notifications,
				])
			);
			if (new_notifications.length > 0) {
				yield put(
					AppActions.set_toast_visible({
						status_toast: true,
						type_toast: TypesErrorRequest.SUCCESS,
						message_toast:
							new_notifications.length > 0 &&
							new_notifications[0].NOTIFICACAO_TITULO,
					})
				);
			}
			yield call(persistStorage, {
				res: [...new_notifications],
				tag: "notifications",
			});
		} else {
			const new_notifications = notificacoes.map((element: any) => {
				return {
					...element,
					IS_NEW: true,
				};
			});
			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.SUCCESS,
					message_toast:
						new_notifications.length > 0 &&
						new_notifications[0].NOTIFICACAO_TITULO,
				})
			);
			yield put(
				DashBoardActions.notificacoes_request_success(new_notifications)
			);

			yield call(persistStorage, {
				res: new_notifications,
				tag: "notifications",
			});
		}
		if (SyncDataHora) {
			yield call(persistStorage, {
				res: SyncDataHora,
				tag: "SyncDataHoraNotifications",
			});
		}
	} catch (e) {
		yield put(DashBoardActions.notificacoes_request_success([]));
	}
}

function* getAssimetria() {
	yield put(DashBoardActions.assimetria_request_loading(true));

	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	const paciente: PacientesProps = yield select(
		(state: any) => state.app.is_open_paciente
	);

	async function apiCall() {
		try {
			const da = {
				TOKEN: user_logado.token,
				ID_USUARIO: paciente.ID_USUARIO,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(da),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/assimetrias`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar Assimetria- getAssimetria',
				tags: {
					endpoint: '/syncs/assimetrias',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw e;
		}
	}

	try {
		const { assimetria, desequilibrios_musculares } = yield call(apiCall);
		yield put(DashBoardActions.assimetria_request_success(assimetria));
		yield put(
			DashBoardActions.desequilibrios_request_success(desequilibrios_musculares)
		);
	} catch (e) {
		yield put(DashBoardActions.assimetria_request_loading(false));
	} finally {
		yield put(DashBoardActions.assimetria_request_loading(false));
	}
}

function* getAnamneses() {
	yield put(DashBoardActions.anamneses_request_loading(true));

	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	const paciente: PacientesProps = yield select(
		(state: any) => state.app.is_open_paciente
	);

	interface ConfigState {
		configs: {
			language: string;
		};
	}

	const language: string = yield select(
		(state: ConfigState) => state.configs.language
	);

	async function apiCall() {
		try {
			const da = {
				TOKEN: user_logado.token,
				ID_USUARIO: paciente.ID_USUARIO,
				txIdioma: language.toLowerCase(),
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(da),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/anamneses`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar Anamnese - getAnamneses',
				tags: {
					endpoint: '/syncs/anamneses',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw e;
		}
	}

	try {
		const { anamneses } = yield call(apiCall);

		yield put(DashBoardActions.anamneses_request_success(anamneses));
	} catch (e) {
		yield put(DashBoardActions.anamneses_request_loading(false));
	} finally {
		yield put(DashBoardActions.anamneses_request_loading(false));
	}
}

function* getAnotacoes() {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const da = {
				TOKEN: user_logado.token,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(da),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/anotacoes`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar Anotações - getAnotacoes',
				tags: {
					endpoint: '/syncs/anotacoes',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw e;
		}
	}

	try {
		const { exibir } = yield call(apiCall);
		yield put(DashBoardActions.anotacoes_request_success(exibir));
	} catch (e) {}
}

function* getBlog() {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const da = {
				TOKEN: user_logado.token,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(da),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}blog`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar Blog - getBlog',
				tags: {
					endpoint: 'blog',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw e;
		}
	}

	try {
		const { posts } = yield call(apiCall);
		yield put(DashBoardActions.set_blog(posts));
	} catch (e) {}
}

function* getDinamos() {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const da = {
				TOKEN: user_logado.token,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(da),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/dinamos`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar dinamos - getDinamos',
				tags: {
					endpoint: '/syncs/dinamos',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw e;
		}
	}

	try {
		const { dinamos } = yield call(apiCall);
		yield put(DashBoardActions.dinamos_request_success(dinamos));
	} catch (e) {}
}

function* getPlanos() {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const da = {
				TOKEN: user_logado.token,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(da),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/planos`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar planos - getPlanos',
				tags: {
					endpoint: '/syncs/planos',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw e;
		}
	}

	try {
		const { planos } = yield call(apiCall);
		yield put(DashBoardActions.planos_request_success(planos));
	} catch (e) {}
}

function* getCategoriesProtocols() {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);
	async function apiCall() {
		try {
			const useToken = {
				TOKEN: user_logado.token,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(useToken),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/categorias_protocolos`,
				requestOptions
			);

			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar categoria protocolos - getCategoriesProtocols',
				tags: {
					endpoint: '/syncs/categorias_protocolos',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw e;
		}
	}

	try {
		const data: any[] = yield call(apiCall);
		yield put(
			DashBoardActions.set_categorias_protocolos_in_modal_filter_protocol(data)
		);
	} catch (error) {}
}

function* AtribuirCategoriaProtocolos({ payload }: any) {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	const data = {
		TOKEN: user_logado.token,
		txDataHora: payload?.txDataHora,
		ID_USUARIO: payload?.id_usuario,
		CATEGORIAS_PROTOCOLOS: payload?.id_categorias,
	};
	async function apiCall() {
		try {
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(data),
			};
			const res = await apiFetchWrite(
				`${process.env.REACT_APP_BASE_URL_V7}protocolos/categorias_atribuir`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao atribuir categoria protocolos - AtribuirCategoriaProtocolos',
				tags: {
					endpoint: '/protocolos/categorias_atribuir',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw e;
		}
	}

	try {
		const data: {
			code: number;
			message: string;
			status: string;
		} = yield call(apiCall);

		if (data?.status === TypesErrorRequest.SUCCESS) {
			yield put(
				DashBoardActions.search_categorias_atribuidas(payload?.id_usuario)
			);
		}
	} catch (error) {}
}

function* SearchCategoriasAtribuidas({ payload }: any) {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);
	const config_servicos: { SERVICO_NOVOS_PROTOCOLOS: boolean } = yield select(
		(state: any) => state.configs.config_servicos
	);

	async function apiCall() {
		try {
			const data = {
				TOKEN: user_logado.token,
				ID_USUARIO: payload,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(data),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/categorias_atribuidas`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao pesquisar categorias atribuidas - SearchCategoriasAtribuidas',
				tags: {
					endpoint: '/syncs/categorias_atribuidas',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw e;
		}
	}

	try {
		const data: { categorias_atribuidas: number[], categorias_atualizadas: any }  = yield call(apiCall);
		const today = moment()
		const checkDate = data?.categorias_atualizadas === "0000-00-00 00:00:00" || data?.categorias_atualizadas < today;
		if(data?.categorias_atribuidas){
			yield put(
				DashBoardActions.get_categorias_atribuidas(data?.categorias_atribuidas)
			);
		}
		if (
			(checkDate || data?.categorias_atribuidas?.length == 0) &&
			config_servicos?.SERVICO_NOVOS_PROTOCOLOS
		) {
			yield put(ManageProtocolActions.set_modal_filter_protocol(true));
		}
	} catch (error) {}
}

function* GetVerificarQuestionarioSatisfacao({ payload }: any) {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);
	const amount_executions: number = yield select(
		(state: any) => state.dashboard.set_quantidade_execucoes
	);
	const questionarioSatisfacaoExameRespondidoExame1: boolean = yield select(
		(state: any) => state.dashboard.resposta_questionario_satisfacao?.EXAME_1
	);
	const questionarioSatisfacaoExameRespondidoExame2: boolean = yield select(
		(state: any) => state.dashboard.resposta_questionario_satisfacao?.EXAME_2
	);

	async function apiCall() {
		const data = {
			TOKEN: user_logado.token,
			txTipo: payload?.txTipo,
			RESPOSTA_ID_TIPO: payload?.resposta_id_tipo,
		};
		const dataExameSatisfacao = {
			TOKEN: user_logado.token,
			txTipos: payload?.txTipos,
		};
		const requestOptionsProtocolo: any = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: "Bearer " + user_logado.token,
			},
			body: JSON.stringify(data),
		};
		const requestOptionSatisfacaoExame: any = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: "Bearer " + user_logado.token,
			},
			body: JSON.stringify(dataExameSatisfacao),
		};
		try {
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}questionarios/verificar_satisfacao`,
				payload?.resposta_id_tipo
					? requestOptionsProtocolo
					: requestOptionSatisfacaoExame
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao verificar questionario satisfacao - GetVerificarQuestionarioSatisfacao',
				tags: {
					endpoint: '/questionarios/verificar_satisfacao',
					file: 'src/store/sagas/dashboard.ts' 
				},
				payload: payload
			})
			throw e;
		}
	}

	try {
		const data: {
			status: string;
			respondido: { EXAME_1: boolean; EXAME_2: boolean };
			resposta: {
				EXAME_1: [{ RESPOSTA_SATISFACAO_CRIADO: string }];
				EXAME_2: [{ RESPOSTA_SATISFACAO_CRIADO: string }];
			};
		} = yield call(apiCall);
		if (data?.status == TypesErrorRequest?.SUCCESS) {
			if (payload?.txTipo === "RELATORIO_UNIFICADO") {
				if (!data?.respondido) {
					// yield put(
					// 	DashBoardActions.set_modal_satisfaction_unified_report(true)
					// );
				}
			} else {
				yield put(
					DashBoardActions.set_info_questionario_satisfacao(
						data?.respondido,
						data?.resposta
					)
				);
			}

			const Now = moment().format("YYYY-MM-DD HH:mm:ss");
			const usuario_criado = moment(user_logado?.USUARIO_CRIADO);
			const currentMoment = moment(Now);
			const dif = currentMoment.diff(usuario_criado, "day");

			if (
				data?.respondido?.EXAME_1 != null &&
				!data?.respondido?.EXAME_2 != null
			) {
				if (
					dif < 35 ||
					(!!data?.respondido?.EXAME_1 && !data?.respondido?.EXAME_2)
				) {
					yield put(DashBoardActions.set_get_amount_executions());
				}

				const today = moment().format("YYYY-MM-DD HH:mm:ss");
				const todayMoment = moment(today);
				const data_resposta_satisfacao = moment(
					data?.resposta?.EXAME_1[0]?.RESPOSTA_SATISFACAO_CRIADO
				);
				const difDays = todayMoment?.diff(data_resposta_satisfacao, "days");

				if (
					amount_executions >= 2 &&
					questionarioSatisfacaoExameRespondidoExame1 == false
				) {
					yield put(AppActions.set_modal_satisfacao_exame(true, "EXAME_1"));
				} else if (
					amount_executions >= 3 &&
					difDays >= 3 &&
					questionarioSatisfacaoExameRespondidoExame2 == false
				) {
					yield put(AppActions.set_modal_satisfacao_exame(true, "EXAME_2"));
				}
			}
		}
	} catch (error) {}
}

function* SalvarQuestionarioSatisfacao({ payload }: any) {
	const current_language: TextsProps = yield select(
		(state) => state.configs.current_language
	);
	const user_logado: UserProps = yield select((state: any) => state.auth.user);
	const data = {
		TOKEN: user_logado.token,
		txDataHora: payload?.txDataHora,
		txTipo: payload?.txTipo,
		RESPOSTA_ID_TIPO: payload?.RESPOSTA_ID_TIPO,
		RESPOSTA_VALOR: payload?.RESPOSTA_VALOR,
		RESPOSTA_COMPLEMENTO: payload?.RESPOSTA_COMPLEMENTO,
	};

	async function apiCall() {
		try {
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(data),
			};
			const res = await apiFetchWrite(
				`${process.env.REACT_APP_BASE_URL_V7}questionarios/salvar_satisfacao`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao salvar questionario satisfacao - SalvarQuestionarioSatisfacao',
				tags: {
					endpoint: '/questionarios/salvar_satisfacao',
					file: 'src/store/sagas/dashboard.ts' 
				},
				payload: payload
			})
			throw e;
		}
	}

	try {
		const data: { status: string; message: string } = yield call(apiCall);
		if (data?.status == TypesErrorRequest?.SUCCESS) {
			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.SUCCESS,
					message_toast: current_language?.questionario_respondido_success,
				})
			);
		} else {
			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.FAIL,
					message_toast: current_language?.questionario_respondido_failure,
				})
			);
		}
	} catch (error) {}
}

function* GetAmountOfExecutions(payload: { payload: number; type: string }) {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	const data = {
		TOKEN: user_logado.token,
	};

	async function apiCall() {
		try {
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(data),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/quantidade_execucoes`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar quantidade de execucoes - GetAmountOfExecutions',
				tags: {
					endpoint: '/syncs/quantidade_execucoes',
					file: 'src/store/sagas/dashboard.ts' 
				},
				payload: payload
			})
			throw e;
		}
	}

	try {
		const data: { quantidade_avaliacoes: number } = yield call(apiCall);
		yield put(
			DashBoardActions.set_amount_executions(data?.quantidade_avaliacoes)
		);
	} catch (error) {}
}

function* getExerciciosAvaliados() {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	const patient: PacientesProps = yield select(
		(state: any) => state.app.is_open_paciente
	);

	async function apiCall() {
		try {
			const useToken = {
				TOKEN: user_logado.token,
				ID_USUARIO: patient.ID_USUARIO,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(useToken),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/exercicios_executados`,
				requestOptions
			);

			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar exercicios avaliados- getExerciciosAvaliados',
				tags: {
					endpoint: '/syncs/exercicios_executados',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw e;
		}
	}

	try {
		const data: any[] = yield call(apiCall);
		yield put(ExerciciosActions.set_exercicios_avaliados(data));
	} catch (error) {}
}

function* getAvaliacoes(): any {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
			};

			const dat = {
				txPeriodo: `0000-00-00/${new Date().toISOString().slice(0, 10)}`,
			};

			const URL = `${process.env.REACT_APP_BASE_URL_V7}dashboard/avaliacoes`;

			try {
				return await axios.post(URL, dat, config);
			} catch (error: any) {
				sendErrorSentryOrLocalHost(error,{
					message: 'Erro ao buscar avaliacoes - getAvaliacoes',
					tags: {
						endpoint: 'dashboard/avaliacoes',
						file: 'src/store/sagas/dashboard.ts' 
					},
				})
				return error;
			}
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar avaliacoes - getAvaliacoes',
				tags: {
					endpoint: 'dashboard/avaliacoes',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw e;
		}
	}

	try {
		const response = yield call(apiCall);
		yield put(DashBoardActions.avaliacoes_request_success(response.data));
	} catch (e) {}
}

function* getAssimetrias(): any {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
			};

			const dat = {
				txPeriodo: `0000-00-00/${new Date().toISOString().slice(0, 10)}`,
			};

			const URL =  `${process.env.REACT_APP_BASE_URL_V7}dashboard/assimetrias`

			return await axios.post(URL, dat, config);
		} catch (error) {
			sendErrorSentryOrLocalHost(error,{
				message: 'Erro ao buscar assimetrias - getAssimetrias',
				tags: {
					endpoint: 'dashboard/assimetrias',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw error;
		}
	}

	try {
		const response = yield call(apiCall);
		response.data.assimetrias = response.data.assimetrias.filter((item:any)=> !item.IDS_ETIQUETAS.includes("3886"))
		yield put(DashBoardActions.assimetrias_dynalabs_request_success(response.data));
	} catch (e) {}
}

function* getPalmarGripe(payload: { payload: number; type: string }) {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);
	const config = {
		headers: {
			"Content-Type": "application/json",
			Authorization: "Bearer " + user_logado.token,
		},
	};
	const dataRequest = {
		ID_USUARIO: payload.payload,
	};
	async function apiCall() {
		try {
			const URL = `${process.env.REACT_APP_BASE_URL_V7}syncs/preensao_palmar`

			return await axios.post(URL, dataRequest, config);
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao sincronizar preensao palmar - getPalmarGripe',
				tags: {
					endpoint:'/syncs/preensao_palmar',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
		}
	}
	try {
		const { data } = yield call(apiCall);

		if (data?.status == "success") {
			yield put(DashBoardActions.set_data_palmar_gripe_report(data));
		}
	} catch (e) {

	}
}

function* getCargos() {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const da = {
				TOKEN: user_logado.token,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(da),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/cargos`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar cargos - getCargos',
				tags: {
					endpoint: '/syncs/cargos',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			throw e;
		}
	}

	try {
		const { cargos } = yield call(apiCall);
		yield put(DashBoardActions.cargos_request_success(cargos));
	} catch (e) {
		yield put(DashBoardActions.cargos_request_failure(e));
	}
}

function* getAnotacoesDynalabs(): any {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
			};

			const dat = {
				ID_FILTRO: 1,
			};

			const URL = `${process.env.REACT_APP_BASE_URL_V7}dashboard/buscar_anotacoes`;

			return await axios.post(URL, dat, config);
		} catch (error) {
			sendErrorSentryOrLocalHost(error,{
				message: 'Erro ao buscar anotações dynalabs - getAnotacoesDynalabs',
				tags: {
					endpoint: 'dashboard/buscar_anotacoes',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
			
			throw error;
		}
	}

	try {
		const response = yield call(apiCall);
		yield put(
			DashBoardActions.anotacoes_dynalabs_request_success(response.data)
		);
	} catch (e) {
		yield put(DashBoardActions.anotacoes_dynalabs_request_failure(e));
	}
}

function* adicionarAnotacaoDynalabs({ payload }: any): any {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
			};

			const URL =  `${process.env.REACT_APP_BASE_URL_V7}dashboard/adicionar_anotacao`;

			return await axios.post(URL, payload, config);
		} catch (error) {
			Sentry.captureMessage(
				"CAIU NO CATCH: /v7/dashboard/adicionar_anotacao",
				"error"
			);
			throw error;
		}
	}

	try {
		const response = yield call(apiCall);
		yield put(
			DashBoardActions.adicionar_anotacao_dynalabs_request_success(
				response.data
			)
		);
		// Após adicionar com sucesso, atualiza a lista de anotações
		yield put(DashBoardActions.anotacoes_dynalabs_request());
	} catch (e) {
		console.log("Erro ao adicionar anotação", e);
		yield put(DashBoardActions.adicionar_anotacao_dynalabs_request_failure(e));
	}
}

function* editarAnotacaoDynalabs({ payload }: any): any {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
			};

			const URL = `${process.env.REACT_APP_BASE_URL_V7}dashboard/editar_anotacao`;

			return await axios.post(URL, payload, config);
		} catch (error) {
			Sentry.captureMessage(
				"CAIU NO CATCH: /v7/dashboard/editar_anotacao",
				"error"
			);
			throw error;
		}
	}

	try {
		const response = yield call(apiCall);
		yield put(
			DashBoardActions.editar_anotacao_dynalabs_request_success(response.data)
		);
		// Após editar com sucesso, atualiza a lista de anotações
		yield put(DashBoardActions.anotacoes_dynalabs_request());
	} catch (e) {
		console.log("Erro ao editar anotação", e);
		yield put(DashBoardActions.editar_anotacao_dynalabs_request_failure(e));
	}
}

function* excluirAnotacaoDynalabs({ payload }: any): any {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
			};

			const URL = `${process.env.REACT_APP_BASE_URL_V7}dashboard/excluir_anotacao`;

			return await axios.post(
				URL,
				{
					txDataHora: `${new Date().toISOString().slice(0, 10)}`,
					ID_ANOTACAO_DASH: payload,
				},
				config
			);
		} catch (error) {
			Sentry.captureMessage(
				"CAIU NO CATCH: /v7/dashboard/excluir_anotacao",
				"error"
			);
			throw error;
		}
	}

	try {
		const response = yield call(apiCall);
		yield put(
			DashBoardActions.excluir_anotacao_dynalabs_request_success(response.data)
		);
		// Após excluir com sucesso, atualiza a lista de anotações
		yield put(DashBoardActions.anotacoes_dynalabs_request());
	} catch (e) {
		console.log("Erro ao excluir anotação", e);
		yield put(DashBoardActions.excluir_anotacao_dynalabs_request_failure(e));
	}
}

function* syncPortaEntrada(payload: { payload: number; type: string }) {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {

		try {
			const da = {
				TOKEN: user_logado.token,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(da),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/portas_entrada`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			throw e;
		}
	}

	try {
		const { portas_entrada } = yield call(apiCall);
		console.log("🚀 ~ dashboard.ts:1686 ~ syncPortaEntrada ~ portas_entrada:", portas_entrada)

		if (portas_entrada?.length > 0) {
			yield put(DashBoardActions.set_entrance_door_data(portas_entrada));
		}
	} catch (error: any) {
		Sentry.captureException(error, {
			tags: { feature: "syncPortaEntrada - Apicall" },
			extra: { endpoint: "/syncs/portas_entrada" },
		});
	}
}

export function* getGerencias() {
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const da = {
				TOKEN: user_logado.token,
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
				body: JSON.stringify(da),
			};
			const res = await apiFetch(
				`${process.env.REACT_APP_BASE_URL_V7}syncs/gerencias`,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			sendErrorSentryOrLocalHost(e, {
				message: "Erro ao buscar gerências - getGerencias",
				tags: {
					endpoint: "/syncs/gerencias",
					file: "src/store/sagas/dashboard.ts",
				},
			});
			throw e;
		}
	}

	try {
		const { gerencias } = yield call(apiCall);
		yield put(DashBoardActions.gerencias_request_success(gerencias));
	} catch (e) {
		yield put(DashBoardActions.gerencias_request_failure(e));
	}
}

function* saveNewFilterDashDynalabs(
	payload: {
		payload: panelCreatedProps; 
		type: string 
	}
) {

	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
			};

		const URL = window.location.hostname === 'https://homologacao.web.elastic.fit/'
			? `https://homologacao.api7.kinology.com.br/v7/dashboard/novo_filtro`
			:  `${process.env.REACT_APP_BASE_URL_V7}dashboard/novo_filtro`;

			return await axios.post(URL,{...payload.payload},	config	);
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao salvar filtro Dyanalabs - saveNewFilterDashDynalabs',
				tags: {
					endpoint: 'dashboard/novo_filtro',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
		}
	}

	try {
		const { data } = yield call(apiCall);
		if(data.status == 'success'){
			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.SUCCESS,
					message_toast: 'Painel salvo com sucesso',
				})
			);
			yield put(DashBoardActions.search_saved_panels_request())
		}
	} catch (e) {
		yield put(DashBoardActions.set_finish_request_new_panel_dashboard_dynalabs())

		yield put(
			AppActions.set_toast_visible({
				status_toast: true,
				type_toast: TypesErrorRequest.FAIL,
				message_toast: 'Erro ao salvar o painel',
			})
		);
	}
}

function* getPanelsSaved() {

	const user_logado: UserProps = yield select((state: any) => state.auth.user);
	const panelDeletedSuccess: boolean = yield select((state:any)=> state.dashboard.panel_delete_success);

	async function apiCall() {
		try {
			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
			};

			const URL = window.location.hostname === 'https://homologacao.web.elastic.fit/'
			? `https://homologacao.api7.kinology.com.br/v7/dashboard/buscar_filtros`
			:  `${process.env.REACT_APP_BASE_URL_V7}dashboard/buscar_filtros`;

			return await axios.post(URL,{},	config	);
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar filtros Dyanalabs - getPanelsSaved',
				tags: {
					endpoint: 'dashboard/novo_filtro',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
		}
	}

	try {
		const { data } = yield call(apiCall);
			if(data.status == 'success'){

				yield put(DashBoardActions.set_data_panels_saved(data?.filtros));

				if(panelDeletedSuccess){
					yield put(DashBoardActions.panel_has_deleted(true));

				}

			}
	} catch (e) {
		yield put(DashBoardActions.set_finish_request_new_panel_dashboard_dynalabs())
		yield put(
			AppActions.set_toast_visible({
				status_toast: true,
				type_toast: TypesErrorRequest.FAIL,
				message_toast: 'Erro ao buscar paineis',
			})
		);
	}finally{
		yield put(DashBoardActions.set_finish_request_new_panel_dashboard_dynalabs())
		yield put(DashBoardActions.finish_request_delete_panel_created_dashboard_dynalabs())
		yield put(DashBoardActions.set_modal_delete_panel_created(false))
	}
};

function* deletePanelCreated(
	payload: {
		payload: {
			txDataHora: string;
			ID_FILTRO: number
		}; 
		type: string 
	}
) {

	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
			};

			const URL =  window.location.hostname === 'https://homologacao.web.elastic.fit/'
			? `https://homologacao.api7.kinology.com.br/v7/dashboard/excluir_filtro`
			: `${process.env.REACT_APP_BASE_URL_V7}dashboard/excluir_filtro`

			

			return await axios.post(URL,{...payload.payload},	config	);
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao excluir filtro Dyanalabs - deletePanelCreated',
				tags: {
					endpoint: 'dashboard/excluir_filtro',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
		}
	}

	try {
		const { data } = yield call(apiCall);
		if(data.status == 'success'){
			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.SUCCESS,
					message_toast: 'Painel excluído com sucesso',
				})
			);
			yield put(DashBoardActions.success_deleted_panel(true))
			yield put(DashBoardActions.search_saved_panels_request())
		}
	} catch (e) {
		yield put(DashBoardActions.finish_request_delete_panel_created_dashboard_dynalabs())

		yield put(
			AppActions.set_toast_visible({
				status_toast: true,
				type_toast: TypesErrorRequest.FAIL,
				message_toast: 'Erro ao deletar o painel',
			})
		);
	}
};

function* editPanelCreated(
	payload: {
		payload: panelCreatedProps; 
		type: string 
	}
) {

	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
			};

			const URL =  window.location.hostname === 'https://homologacao.web.elastic.fit/'
			? 'https://homologacao.api7.kinology.com.br/v7/dashboard/editar_filtro'
			: `${process.env.REACT_APP_BASE_URL_V7}dashboard/editar_filtro`

			return await axios.post(URL,{...payload.payload},	config	);
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao editar filtro Dyanalabs - editPanelCreated',
				tags: {
					endpoint: 'dashboard/editar_filtro',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
		}
	}

	try {
		const { data } = yield call(apiCall);
		if(data.status == 'success'){
			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.SUCCESS,
					message_toast: 'Painel editado com sucesso',
				})
			);
			yield put(DashBoardActions.search_saved_panels_request())
		}
	} catch (e) {
		yield put(DashBoardActions.set_finish_request_new_panel_dashboard_dynalabs())

		yield put(
			AppActions.set_toast_visible({
				status_toast: true,
				type_toast: TypesErrorRequest.FAIL,
				message_toast: 'Erro ao editar o painel',
			})
		);
	}
};

function* checkAnswerNps (
	action: { 
		type: typeof Types.REQUEST_VERIFY_ANSWER_NPS, 
		payload: string
	}
){
	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	
	const data_request = {
		txTrimestre: action?.payload,
	};

		const data = {
			TOKEN: user_logado.token,
			txTrimestre: action?.payload,
		};
		const requestOptions: any = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: "Bearer " + user_logado.token,
			},
			body: JSON.stringify(data),
		};
		

	async function apiCall() {
		try {

			const URL = `${process.env.REACT_APP_BASE_URL_V7}questionarios/verificar_nps`
			
			const res = await apiFetch(
				URL,
				requestOptions
			);
			return await res.json()
		} catch (e) {
			console.log(e);
			throw e;
		}
	};
	try{
		const data: {
				status: string;
				code: number;
				respondido: boolean;
				resposta: AnswerNpsProps[]
		} = yield call(apiCall)
		
		if(data.status === 'success' ){
			yield put(AppActions.set_virify_nps_data(data.respondido, data.resposta))
		}		
	}catch(error){
		Sentry.captureException(error, {
			tags: { feature: 'checkAnswerNps' },
			extra: { endpoint: '/questionarios/verificar_nps' },
		});
	}
};
function* saveAnswerNps (
	action: { 
		type: typeof Types.REQUEST_SAVE_ANSWER_NPS, 
		payload: {
			txTrimestre: string;
			firstAnswer: string;
			secondAnswer: string;
		}
	}
){
	const current_language: TextsProps = yield select(
		(state) => state.configs.current_language,
	);
	const user_logado: UserProps = yield select((state: any) => state.auth.user);
	

	const data = {
			TOKEN: user_logado.token,
			txDataHora: moment(new Date()).format('YYYY-MM-DD HH:mm:ss').toString(),
			txTrimestre: action?.payload?.txTrimestre,
			RESPOSTA_VALOR_1: action?.payload?.firstAnswer,
			RESPOSTA_VALOR_2: action?.payload?.secondAnswer,
		};
		const requestOptions: any = {
			method: "POST",
			headers: {
				"Content-Type": "application/json",
				Authorization: "Bearer " + user_logado.token,
			},
			body: JSON.stringify(data),
		};
	async function apiCall() {
		try {

			const URL =  `${process.env.REACT_APP_BASE_URL_V7}questionarios/salvar_nps`
			const res = await apiFetchWrite(
				URL,
				requestOptions
			);
			const response: any = await res.json();
			return response;
		} catch (e) {
			console.log(e);
			throw e;
		}
	};
	try{
		const {data} = yield call(apiCall)
		
		if(data.status === 'success'){
		
			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.SUCCESS,
					message_toast: current_language?.nota_satisfacao_nps_enviada,
				})
			);
			yield put(AppActions.set_virify_nps_data(null, null))
		}		
	}catch(error){
		Sentry.captureException(error, {
			tags: { feature: 'checkAnswerNps' },
			extra: { endpoint: '/questionarios/salvar_nps' },
		});
	}finally{
			// yield put(AppActions.set_modal_nps(false))
	}
}

function* exportExcelDash(
	payload:any
) {

	const user_logado: UserProps = yield select((state: any) => state.auth.user);

	async function apiCall() {
		try {
			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
			};

	

			const URL =   window.location.hostname === 'https://homologacao.web.elastic.fit/'
			? 'https://homologacao.api7.kinology.com.br/v7/dashboard/exportar_excel'
			: `${process.env.REACT_APP_BASE_URL_V7}dashboard/exportar_excel`


			return await axios.post(URL,{...payload.payload},	config	);
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao exportar excel - exportExcelDash',
				tags: {
					endpoint: 'dashboard/exportar_excel',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
		}
	}

	try {
		const { data } = yield call(apiCall);

		if(data.status == 'success'){
			window.open(data?.message, '_blank')
		}else{
			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.FAIL,
					message_toast: 'Erro ao exportar planilha',
				})
			);
		}
	} catch (e) {

		yield put(
			AppActions.set_toast_visible({
				status_toast: true,
				type_toast: TypesErrorRequest.FAIL,
				message_toast: 'Erro ao exportar planilha',
			})
		);
	}finally{
		yield put(DashBoardActions.set_load_request_export_excel_dash(false))
	}
};
function* getRecomendationDash(
	payload:any
) {
	
	const user_logado: UserProps = yield select((state: any) => state.auth.user);
	
	async function apiCall() {
		try {
			const dataRequest ={
				ID_USUARIO: payload.payload
			}
			const config = {
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
			};

			const URL =   window.location.hostname === 'https://homologacao.web.elastic.fit/'
			? 'https://homologacao.api7.kinology.com.br/v7/syncs/recomendacoes'
			: `${process.env.REACT_APP_BASE_URL_V7}syncs/recomendacoes`


			return await axios.post(URL,dataRequest,	config	);
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao buscar recomendação de conduta - getRecomendationDash',
				tags: {
					endpoint: 'syncs/recomendacoes',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
		}
	}

	try {
		const { data } = yield call(apiCall);

		if(data.status == 'success'){
			yield put(DashBoardActions?.set_recomendacao_sugestao_conduta(data?.recomendacoes[0]))
		}else{
			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.FAIL,
					message_toast: 'Erro ao exportar planilha',
				})
			);
		}
	} catch (e) {

		yield put(
			AppActions.set_toast_visible({
				status_toast: true,
				type_toast: TypesErrorRequest.FAIL,
				message_toast: 'Erro ao buscar recomendação de conduta',
			})
		);
	}finally{
		yield put(DashBoardActions.set_load_request_export_excel_dash(false))
	}
};
function* setRecomendationDash(
	payload:any
) {

	const user_logado: UserProps = yield select((state: any) => state.auth.user);
	const paciente: PacientesProps = yield select(
		(state: any) => state.app.is_open_paciente
	);

	async function apiCall() {
		try {
			const data = {
				txDataHora: moment(new Date()).format("YYYY-MM-DD HH:mm:ss").toString(),
				ID_USUARIO: paciente?.ID_USUARIO,
				RECOMENDACAO_VALOR: [String(payload?.payload)]
			};
			const requestOptions: any = {
				method: "POST",
				headers: {
					"Content-Type": "application/json",
					Authorization: "Bearer " + user_logado.token,
				},
			};
		

			const URL =   window.location.hostname === 'https://homologacao.web.elastic.fit/'
			? 'https://homologacao.api7.kinology.com.br/v7/recomendacoes/adicionar'
			: `${process.env.REACT_APP_BASE_URL_V7}recomendacoes/adicionar`


			return await axios.post(URL,data,	requestOptions	);
		} catch (e) {
			sendErrorSentryOrLocalHost(e,{
				message: 'Erro ao salvar recomendação de conduta - getRecomendationDash',
				tags: {
					endpoint: 'recomendacoes/adicionar',
					file: 'src/store/sagas/dashboard.ts' 
				},
			})
		}
	}

	try {
		const { data } = yield call(apiCall);

		if(data.status == 'success'){
			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.SUCCESS,
					message_toast: 'Conduta salva com sucesso',
				})
			);
		}else{
			yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.FAIL,
					message_toast: 'Erro ao salvar conduta',
				})
			);
		}
	} catch (e) {

		yield put(
				AppActions.set_toast_visible({
					status_toast: true,
					type_toast: TypesErrorRequest.FAIL,
					message_toast: 'Erro ao salvar conduta',
				})
			);
	}
};

export function* DashBoardSaga(): any {
	return yield all([
		takeLatest(Types.PACIENTE_REQUEST, getPacientes),
		takeLatest(Types.PACIENTE_NOTIFICATION_REQUEST, getPacientesNotification),
		takeLatest(Types.AVALIADORES_REQUEST, getAvaliadores),
		takeLatest(Types.PROTOCOLOS_REQUEST, getProtocolos),
		takeLatest(Types.EXERCICES_REQUEST, getExercises),
		takeLatest(Types.EXECUCOES_REQUEST, getExecucoes),
		takeLatest(Types.ETIQUETAS_REQUEST, getEtiquetas),
		takeLatest(Types.NOTIFICACOES_REQUEST, getNotificacoes),
		takeLatest(Types.ASSIMETRIA_REQUEST, getAssimetria),
		takeLatest(Types.ANAMNESES_REQUEST, getAnamneses),
		takeLatest(Types.ANOTACOES_REQUEST, getAnotacoes),
		takeLatest(Types.EXERCICIOS_AVALIADOS_REQUEST, getExerciciosAvaliados),
		takeLatest(Types.DINAMOS_REQUEST, getDinamos),
		takeLatest(Types.BLOG, getBlog),
		takeLatest(Types.PLANOS_REQUEST, getPlanos),
		takeLatest(Types.PACIENTES_MAIS_VISITADOS_REQUEST, getMaisVisitados),
		takeLatest(Types.CATEGORIAS_PROTOCOLOS, getCategoriesProtocols),
		takeLatest(
			Types.ATRIBUIR_CATEGORIA_PROTOCOLOS,
			AtribuirCategoriaProtocolos
		),
		takeLatest(Types.SEARCH_CATEGORIAS_ATRIBUIDAS, SearchCategoriasAtribuidas),
		takeLatest(
			Types.SET_QUESTIONARIO_SATISFACAO_VERIFICAR,
			GetVerificarQuestionarioSatisfacao
		),
		takeLatest(
			Types.SALVAR_QUESTIONARIO_SATISFACAO,
			SalvarQuestionarioSatisfacao
		),
		takeLatest(Types.GET_QUANTIDADE_EXECUCOES, GetAmountOfExecutions),
		takeLatest(Types.PREENSAO_PALMAR_REQUEST, getPalmarGripe),
		takeLatest(Types.AVALIACOES_DYNALABS_REQUEST, getAvaliacoes),
		takeLatest(Types.ASSIMETRIAS_DYNALABS_REQUEST, getAssimetrias),
		takeLatest(Types.CARGOS_REQUEST, getCargos),
		takeLatest(Types.ANOTACOES_DYNALABS_REQUEST, getAnotacoesDynalabs),
		takeLatest(
			Types.ADICIONAR_ANOTACAO_DYNALABS_REQUEST,
			adicionarAnotacaoDynalabs
		),
		takeLatest(Types.EDITAR_ANOTACAO_DYNALABS_REQUEST, editarAnotacaoDynalabs),
		takeLatest(
			Types.EXCLUIR_ANOTACAO_DYNALABS_REQUEST,
			excluirAnotacaoDynalabs
		),
		takeLatest(Types.PORTA_ENTRADA_REQUEST, syncPortaEntrada),
		takeLatest(Types.GERENCIAS_REQUEST, getGerencias),
		takeLatest(Types.REQUEST_NEW_PANEL_DASHBOARD_DYNALABS, saveNewFilterDashDynalabs),
		takeLatest(Types.SEARCH_SAVED_PANELS_REQUEST, getPanelsSaved),
		takeLatest(Types.REQUEST_EDIT_PANEL_CREATED_DASHBOARD_DYNALABS, editPanelCreated),
		takeLatest(Types.REQUEST_DELETE_PANEL_CREATED_DASHBOARD_DYNALABS, deletePanelCreated),
		takeLatest(Types.REQUEST_VERIFY_ANSWER_NPS, checkAnswerNps ),
		takeLatest(Types.REQUEST_SAVE_ANSWER_NPS, saveAnswerNps ),
		takeLatest(Types.SET_REQUEST_EXPORT_EXCEL_DASH, exportExcelDash),
		takeLatest(Types.REQUEST_RECOMENDACOES, getRecomendationDash),
		takeLatest(Types.SET_SUGESTAO_CONDUTA_RESULT, setRecomendationDash),
	]);
}
